var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 879 111",
    style: {
      enableBackground: "new 0 0 879 111"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:none;stroke:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,91.8V19.1h18.7v56.3h29.2v16.3H7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.1,91.8V19.1h53.3v15.8H90.8V47h33.8v15.9H90.8V76h34.6v15.8H72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.4,91.8l-3.7-11h-30.2l-3.7,11h-20.4l27.4-72.7h23.5l27.5,72.7H193.4z M174.5,35.4L164.4,65h20.4 L174.5,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226,91.8V19.1h30.5c22.9,0,39.3,13.7,39.3,36.3c0,22.6-16.5,36.4-39.2,36.4H226z M244.7,75.4h11.8 c12.8,0,20.2-9.3,20.2-20.1c0-11.2-6.8-19.9-20.1-19.9h-11.9V75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.1,91.8V19.1h53.3v15.8h-34.6V47h33.8v15.9h-33.8V76h34.6v15.8H312.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.7,91.8l-12.2-24.6h-9.6v24.6h-18.7V19.1h36.4c16.1,0,25.3,10.7,25.3,24.2c0,12.6-7.7,19.4-14.5,21.8 l14.8,26.7H423.7z M416.7,34.9h-14.8v16.3h14.8c4.9,0,9-3.2,9-8.2S421.6,34.9,416.7,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M462.1,91.8V19.1h41.2c14.4,0,21.3,9.4,21.3,18.5c0,9-5.6,15.2-12.4,16.7c7.7,1.2,13.8,8.6,13.8,17.8 c0,10.6-7.1,19.7-21.4,19.7H462.1z M480.8,47.2H499c3.8,0,6.4-2.7,6.4-6.3c0-3.6-2.6-6.2-6.4-6.2h-18.2V47.2z M480.8,76.2h18.9 c4.5,0,7.2-2.7,7.2-6.6c0-3.7-2.6-6.9-7.2-6.9h-18.9V76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M578.3,17.9c22.2,0,38.8,15.5,38.8,37.6s-16.6,37.6-38.8,37.6c-22.2,0-38.9-15.5-38.9-37.6 S556,17.9,578.3,17.9z M578.3,34.5c-12.1,0-19.8,9.2-19.8,21c0,11.8,7.7,21,19.8,21c12,0,19.7-9.3,19.7-21 C598,43.6,590.2,34.5,578.3,34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M680.2,91.8l-3.7-11h-30.2l-3.7,11h-20.4l27.4-72.7h23.5l27.5,72.7H680.2z M661.3,35.4L651.2,65h20.4 L661.3,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M753.3,91.8l-12.2-24.6h-9.6v24.6h-18.7V19.1h36.4c16.1,0,25.3,10.7,25.3,24.2c0,12.6-7.7,19.4-14.5,21.8 l14.8,26.7H753.3z M746.3,34.9h-14.8v16.3h14.8c4.9,0,9-3.2,9-8.2S751.2,34.9,746.3,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M791.7,91.8V19.1h30.5c22.9,0,39.3,13.7,39.3,36.3c0,22.6-16.5,36.4-39.2,36.4H791.7z M810.4,75.4h11.8 c12.8,0,20.2-9.3,20.2-20.1c0-11.2-6.8-19.9-20.1-19.9h-11.9V75.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/LEADERBOARD.f46a206860a9f3b3785453c59afe5669.svg";
export { ForwardRef as ReactComponent };